import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";

function Footer() {
    
    const { t } = useTranslation();
    
    return (
        <div className="kt-footer">
            <div className="kt-footer-content">
                <div className="kt-footer-row">
                    <Link to={`/contact`}>{t("contact")}</Link>
                    <Link to={`/terms`}>{t("termsOfUse")}</Link>
                    <Link to={`/legal-notice`}>{t("imprint")}</Link>
                    <Link to={`/data-protection`}>{t("privacyPolicy")}</Link>
                </div>
                <div className="kt-footer-row">
                    <span>&copy; 2025 Pickadoc.de</span>
                </div>
            </div>
        </div>
    );
}

export default Footer;